export const msalConfig = {
  auth: {
    clientId: '9fda9382-ebae-4863-b035-ef06f53f7abd',
    authority: 'https://login.microsoftonline.com/0b3fc178-b730-4e8b-9843-e81259237b77/',
    redirectUri: process.env.REACT_APP_DEV_URL + 'view',
    postLogoutRedirectUri: process.env.REACT_APP_DEV_URL,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}

export const loginRequest = {
  scopes: ['User.Read']
}

const apiConfig = {
  uri: 'http://localhost:7071/api',
  scopes: ['api://b4cc6c99-2666-4138-88fa-0b031c062b3d/access_as_user']
}

export const tokenRequest = {
  scopes: apiConfig.scopes
}
